import { Button, Icons, Option, Select } from "@ster/ster-toolkit";
// eslint-disable-next-line import/no-extraneous-dependencies
import { LabelInValueType, RawValueType } from "rc-select/lib/Select";
import React, { useCallback, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import styles from "./AddConversionGroup.module.less";
import { conversionGroupsState, metadataState } from "./atoms";
import { Campaign } from "./Compare";
import HelpText from "./HelpText";

const AddConversionGroup = ({
  campaigns,
  medium,
}: {
  campaigns: Partial<Campaign>[];
  medium: string;
}): JSX.Element => {
  const [conversionGroups, setConversionGroups] = useRecoilState(
    conversionGroupsState
  );
  const metadata = useRecoilValue(metadataState(medium));

  const [selectedConversionGroup, setSelectedConversionGroup] = useState<
    string | undefined
  >(undefined);

  const handleChangeConversionGroup = useCallback(
    (value: RawValueType | LabelInValueType) => {
      setSelectedConversionGroup(value as string);
    },
    []
  );

  const handleAddConversionGroup = useCallback(() => {
    if (selectedConversionGroup) {
      setConversionGroups([
        ...conversionGroups,
        {
          label:
            metadata.targetGroups.find(
              (c) => c.value === selectedConversionGroup
            )?.label ?? "",
          value: selectedConversionGroup,
        },
      ]);
      setSelectedConversionGroup(undefined);
    }
  }, [
    conversionGroups,
    metadata.targetGroups,
    selectedConversionGroup,
    setConversionGroups,
  ]);

  return (
    <div className={styles.container}>
      <div className={styles.addConversionGroup}>
        <Select.Search
          placeholder="Kies jouw communicatiedoelgroep"
          optionFilterProp="children"
          onSelect={handleChangeConversionGroup}
          value={selectedConversionGroup ?? []}
        >
          {metadata.targetGroups
            .filter(
              (s) => !campaigns.map((c) => c.targetGroup).includes(s.value)
            )
            .filter((s) => !conversionGroups?.some((c) => c.value === s.value))
            .map((conversionGroup) => (
              <Option value={conversionGroup.value} key={conversionGroup.value}>
                {conversionGroup.label}
              </Option>
            ))}
        </Select.Search>
        <Button
          mode="tertiary"
          disabled={!selectedConversionGroup}
          onClick={handleAddConversionGroup}
        >
          <Icons.PlusIcon fill="#008ccc" />
          Voeg doelgroep toe
        </Button>
        <HelpText
          text={
            <>
              Kies hier voor jouw communicatiedoelgroep of de
              communicatiedoelgroep die het meest past bij jouw daadwerkelijke
              doelgroep. Dit geldt als jouw doelgroep niet in een van de
              standaard inkoopdoelgroepen valt.
            </>
          }
        />
      </div>
    </div>
  );
};

export default AddConversionGroup;
